import { toast } from 'sonner'
import { absoluteAppUrl } from '@/lib/app-routes'

/** Tab id the chat stream already treats as an inbox thread (not a document UUID). */
export function inboxThreadTabId(threadId: string): string {
  return `inbox-thread-${threadId}`
}

export function inboxThreadSharePath(threadId: string): string {
  return `/inbox/thread/${threadId}`
}

export function inboxThreadShareUrl(threadId: string): string {
  return absoluteAppUrl(inboxThreadSharePath(threadId))
}

/** Composer chip. The stream loads the thread body from the inbox-thread- id. */
export function dispatchInboxThreadAddToChat(threadId: string, title?: string): void {
  const label = title?.trim() || 'Inbox thread'
  window.dispatchEvent(
    new CustomEvent('add-to-chat', {
      detail: {
        id: inboxThreadTabId(threadId),
        title: label,
        name: label,
        path: inboxThreadSharePath(threadId),
        documentType: 'note',
      },
    }),
  )
  toast.success('Added to chat', { description: label })
}

export async function copyInboxThreadLink(threadId: string): Promise<void> {
  const url = inboxThreadShareUrl(threadId)
  try {
    await navigator.clipboard.writeText(url)
    toast.success('Link copied')
  } catch {
    toast.error('Could not copy link')
  }
}
